import {
    Text,
    Stack,
    Icon,
    mergeStyleSets,
    DocumentCardPreview,
    DocumentCard,
    TooltipHost,
} from "@fluentui/react";
import { commonCardStyles } from "./CardStyles";
import "./LearningcardStyle.scss";
import { getCardPreviewProps } from "./CardHelpers";
import { LearningType } from "../../Types/LearningType";
import { Link } from "@fluentui/react-components";
import { trackEvent } from '../../utilities/AppInsights';
import appInsights, { generateCookieId } from "../../utilities/AppInsights";
import { useEffect, useState } from "react";

export type ICardProps = {
    cardData: LearningType;
};

const blogStyles = {
    spotlightBlog: {
        backgroundColor: "#0010A4",
    },
    contentText: {
        marginRight: "10px",
    },
    blogActivity: {
        top: "20px",
        position: "relative",
    },
    icon: {
        fontSize: "9px",
        color: "white",
        marginRight: "5px",
        marginLeft: "5px",
        position: "relative",
        top: "4px",
        left: "6px",
    },
    subTitle: {
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "5",
        textOverflow: "ellipsis",
        fontSize: "14px",
        color: "#0E1726",
        margin: "6px 10px",
        fontWeigt: 400,

    },
    title: {
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "2",
        textOverflow: "ellipsis",
        fontSize: "18px",
        color: "#0E1726",
        fontWeight: "700",
        margin: "6px 8px",
        fontWeigt: 600,
    },
    linkFocus: {
        ':focus-visible': {
            outline: "none !important",
            textDecorationStyle: "solid !important",
            textDecorationLine: "underline !important"
        }
    },
    cardTitle: {
        display: "-webkit-box",
        overflow: "hidden",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: "2",
        textOverflow: "ellipsis",
        fontSize: "13px",
        color: "#0078D4",
        fontWeight: "700",
        padding: "5px 8px",
        paddingTop: "12px",
        fontWeigt: 600,
    },
    linkColor: {
        color: "#0067B8 !important"
    },
    buttonWidth: {
        width: "140px",
        "@media (max-width: 1470px)": {
            width: "100px"
        },
        "@media (max-width: 1310px)": {
            width: "88px"
        },
        "@media (max-width: 1198px)": {
            width: "140px",
        },
        "@media (max-width: 768px)": {
            width: "88px"
        },
        "@media (max-width: 600px)": {
            width: "200px",
        },
        "@media (max-width: 400px)": {
            width: "130px",
        },
    }
};

const styles = mergeStyleSets(blogStyles, commonCardStyles);

const LearningCard: React.FC<ICardProps> = ({ cardData }) => {
    // const data = cardData as LearningType;
    const images = (require as any).context("../../assets", true);
    const isRTL = document.body.classList.contains('langdirection-rtl');

    const [previewProps, setPreviewProps] = useState<any>(null); // Store the preview props

    useEffect(() => {
        const fetchPreviewProps = async () => {
            const props = await getCardPreviewProps(cardData);
            setPreviewProps(props);
        };
        fetchPreviewProps();
    }, [cardData]); // Re-run when cardData changes

    const handleCardClick = () => {
        trackEvent('LearningCardexternalLinkClick', {
            Title: cardData.title,
            ButtonText: cardData.buttonText,
            ExternalLink: cardData.learnMoreUrl,
            visitorId: generateCookieId()
        });
        window.open(cardData.learnMoreUrl, "_blank", "noopener,noreferrer");
    };

    return (
        <DocumentCard className={styles.card} onClick={handleCardClick} tabIndex={0}>
            {/* Only render preview when props are ready */}
            {previewProps && (
                <DocumentCardPreview styles={{ root: { borderRadius: "24px" } }} {...previewProps} />
            )}

            <Stack className={styles.cardDescription}>
                <TooltipHost content={cardData.heading}>
                    <Text className={styles.cardTitle} title={cardData.heading}>{cardData.heading}</Text>
                </TooltipHost>
                <TooltipHost content={cardData.title}>
                    <Text className={styles.title}>{cardData.title}</Text>
                </TooltipHost>
                <TooltipHost content={cardData.description}>
                    <Text className={styles.subTitle}>{cardData.description}</Text>
                </TooltipHost>

                <Stack horizontal horizontalAlign="space-between" style={{ margin: "6px 0px" }}>
                    <Stack.Item >
                        <Link href={cardData.learnMoreUrl} target="_blank" className={styles.linkFocus} onClick={(e) => e.stopPropagation()} rel="noopener noreferrer">
                            <Stack horizontal >
                                <div className="linkButton">
                                    <Icon iconName={isRTL ? "ChevronLeft" : "ChevronRight"} className={styles.icon} />
                                </div>
                                <span title={cardData.buttonText} className={`linkText ${styles.linkColor} ${styles.buttonWidth}`} >
                                    {cardData.buttonText}
                                </span>
                            </Stack>
                        </Link>
                    </Stack.Item>
                    <Stack.Item >
                        <Stack className="linkinButton" horizontal style={{ position: "relative" }} >
                            {cardData.logoUrl && (
                                <img src={(cardData.logoUrl.startsWith('http://') || cardData.logoUrl.startsWith('https://')) ? cardData.logoUrl : images(`./${cardData.logoUrl}`)} alt="Learn Source" style={{ height: "29px", maxWidth:"90px" }} />
                            )}
                            {cardData.logoText?.trim() && (
                                <span className="linkText linkCategory" title={cardData.logoText}>
                                    {cardData.logoText}
                                </span>
                            )}
                        </Stack>
                    </Stack.Item>
                </Stack>
            </Stack>
        </DocumentCard>
    );
};

export default LearningCard;
